// Terms pass B — legacy (2026 cohort) notice screen: wording, contacts import, recipient selection, send.
import { useCallback, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useTermsScope } from "@/lib/termsAccess";
import { call, errText, btn } from "@/components/terms/legacy/shared";
import { NoticeWording } from "@/components/terms/legacy/NoticeWording";
import { ContactImport } from "@/components/terms/legacy/ContactImport";
import { LegacyAccounts } from "@/components/terms/legacy/LegacyAccounts";
import { SendPanel } from "@/components/terms/legacy/SendPanel";

export default function TermsLegacy() {
  const { slug } = useParams();
  const { scope, err: scopeErr } = useTermsScope();
  const ts = scope?.tenant_slug;
  const [acc, setAcc] = useState(null);
  const [c, setC] = useState(null);
  const [err, setErr] = useState(null);
  const load = useCallback(() => {
    if (!ts) return;
    Promise.all([call("get", "/accounts", ts), call("get", "/campaign", ts)])
      .then(([a, camp]) => { setAcc(a); setC(camp); }).catch((e) => setErr(errText(e)));
  }, [ts]);
  useEffect(() => { load(); }, [load]);
  if (scopeErr || err) return <div className="text-sm text-[#b91c1c]" data-testid="legacy-error">{scopeErr || err}</div>;
  if (!acc || !c) return null;
  const perms = acc.permissions;
  const seed = async () => { try { await call("post", "/seed", ts); load(); } catch (e) { setErr(errText(e)); } };
  return (
    <div className="space-y-4" data-testid="terms-legacy-page">
      <div className="flex items-end justify-between gap-3 flex-wrap">
        <h1 className="text-3xl font-semibold text-[#0e1420]">Legacy terms notice <span className="text-base text-[#6b7280]">cohort 2026</span></h1>
        <span className={`text-xs font-bold ${c.approval_label === "APPROVED" ? "text-[#0e6b52]" : "text-[#b91c1c]"}`} data-testid="legacy-campaign-label">Campaign {c.approval_label}</span>
      </div>
      {acc.items.length === 0 && (
        <div className="text-sm text-[#6b7280]" data-testid="legacy-empty">No legacy accounts yet.
          {perms.is_platform_admin && <button className={`${btn} ml-3`} onClick={seed} data-testid="legacy-seed">Load the 51 legacy accounts</button>}</div>
      )}
      <NoticeWording key={c.current_hash} slug={ts} c={c} perms={perms} onChange={setC} />
      <ContactImport slug={ts} edit={perms.can_review} onImported={load} />
      {acc.items.length > 0 && <LegacyAccounts slug={ts} rows={acc.items} edit={perms.can_review}
        onRowSaved={(row) => { setAcc({ ...acc, items: acc.items.map((r) => (r.id === row.id ? { ...r, ...row } : r)) }); load(); }}
        onSelectionSaved={(ids) => { setAcc({ ...acc, items: acc.items.map((r) => ({ ...r, notice_selected: ids.includes(r.id) })) }); load(); }} />}
      <SendPanel slug={ts} c={c} admin={perms.is_platform_admin} onDone={load} />
    </div>
  );
}
